import { featureModuleTypesEnum } from "helpers/enums/featureModuleTypes";
import { getInitialStateFromConfig } from "helpers/form";

const config = {
    bidCreator: {
        title: "Автор заявки",
        name: {
            bWrapper: "row",
            inputProps: { name: "name" },
        },
        isHidden: {
            bWrapper: "row",
            inputProps: { name: "isHidden" },
            checkbox: true,
        },
    },
    logist: {
        title: "Логист",
        name: {
            bWrapper: "row",
            inputProps: { name: "name" },
        },
        isHidden: {
            bWrapper: "row",
            inputProps: { name: "isHidden" },
            checkbox: true,
        },
    },
    responsibleForBid: {
        title: "Ответственный заявки",
        name: {
            bWrapper: "row",
            inputProps: { name: "name" },
        },
        isHidden: {
            bWrapper: "row",
            inputProps: { name: "isHidden" },
            checkbox: true,
        },
    },
    salesManager: {
        title: "Менеджер по продажам",
        name: {
            bWrapper: "row",
            inputProps: { name: "name" },
        },
        isHidden: {
            bWrapper: "row",
            inputProps: { name: "isHidden" },
            checkbox: true,
        },
        requiredModule: featureModuleTypesEnum.BidSalesManager,
    },
};

const initialState = getInitialStateFromConfig(config);

export { config, initialState };
